import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>ビジネスモデルキャンバス</>,
  alt: 'ビジネスモデルキャンバス',
  readText: <>人、もの、お金を可視化し、事業の構造をとらえるフレームワーク</>,
  imgLarge: '/images/img/download/business-model/thumbnail_bmc.webp',
  imgCapture: '/images/img/download/business-model/capture_bmc.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      この資料ではビジネス構造を可視化し、より強固なビジネスモデルへ導く方法について解説しております。既存事業のビジネス構造を可視化したい方や、今すぐ使えるビジネスモデルキャンバス設計のテンプレートを手に入れたい方におすすめの資料です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'ビジネス構造を可視化し、より強固なビジネスモデルへ導く方法',
  secondHalf2: 'ビジネスモデルキャンバスを設計する際のポイントや運用時の注意点',
  secondHalf3: '今すぐ使えるビジネスモデルキャンバスのテンプレート',
}

const DownloadBusinessmodel: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', '1ecff6f5-442d-406e-9f13-93e6abb987fd', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], { opacity: 0, y: 50 });

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    });

    const commonTo = { opacity: 1, y: 0 };

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1);
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents
            leftContentData={leftContentData}
            isSecondContent={true}
          />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadBusinessmodel
